<template>
  <div class="col-12">
    <ValidationProvider name="third_party_uploader" rules="required" v-slot="{ errors }"  mode="lazy" tag="div">
      <div class="form-group-beside row mt-4 ml-0 mr-0 form-field-wrapper" :class="{ 'required': errors[0]}">
        <label for="third_party_uploader" class="col-2 col-md-6 mt-3">Will someone upload on your behalf? <em class="yellow no-style">*</em></label>
        <div class="col-10 col-md-6 input-wrapper" :class="(!update_allowed) ? 'no-hover' : ''">
          <div class="toggle-js">
            <span class="yes-toggle" :class="thirdPartyUploaderActiveClass" @click="thirdPartyUploaderActive(1)"><checkmark class="svg-18 svg-black"></checkmark> Yes</span>
            <span class="no-toggle"  :class="thirdPartyUploaderActiveClass" @click="thirdPartyUploaderActive(0)"><closeicon class="svg-18 svg-black"></closeicon> No</span>
          </div>
          <input type="hidden" v-model="orderinfo.third_party_uploader" id="third_party_uploader" class="form-control third_party_uploader">
        </div>
      </div>
    </ValidationProvider>

    <div class="pt-4 pb-5 pl-5 pr-5 background-light-grey" v-if="orderinfo.third_party_uploader == 1">
      <h3>Send Video File Request</h3>
      <p>Send a request to have a video file uploaded on your behalf.</p>
      <ValidationProvider  name="third_party_uploader_name" rules="required" v-slot="{ errors }" mode="lazy" tag="div" v-if="orderinfo.third_party_uploader == 1">
        <div class="form-group-beside row ml-0" :class="{ 'required': errors[0]}">
          <label for="third_party_uploader_name" class="col-2 col-md-6">Uploader Name: <em class="yellow no-style">*</em></label>
          <div class="col-10 col-md-6 input-wrapper">
            <input type="text" v-model="orderinfo.third_party_uploader_name" name="third_party_uploader_name" id="third_party_uploader_name" class="form-control third_party_uploader_name" autocomplete="on" :disabled="(is_viewing_mode)?true:false">
          </div>
        </div>
      </ValidationProvider>
      <ValidationProvider name="third_party_uploader_email" rules="required|email" v-slot="{ errors }"  mode="lazy" tag="div" v-if="orderinfo.third_party_uploader == 1">
        <div class="form-group-beside row ml-0" :class="{ 'required': errors[0]}">
          <label for="third_party_uploader_email" class="col-2 col-md-6">Uploader Email: <em class="yellow no-style">*</em></label>
          <div class="col-10 col-md-6 input-wrapper">
            <input type="email" v-model="orderinfo.third_party_uploader_email" id="third_party_uploader_email" class="form-control third_party_uploader_email" autocomplete="on" :disabled="(is_viewing_mode)?true:false">
          </div>
        </div>
      </ValidationProvider>
      <div class="form-group-beside row ml-0" v-if="orderinfo.third_party_uploader == 1">
        <label for="third_party_uploader_message" class="col-2 col-md-6">Notes to Uploader
          <div class="description">Ex: list the episode(s) to be uploaded</div>
        </label>
        <div class="col-10 col-md-6 input-wrapper">
          <textarea rows="5" type="text" id="third_party_uploader_message" class="form-control" v-model="orderinfo.third_party_uploader_message" :disabled="(is_viewing_mode)?true:false"></textarea>
        </div>
      </div>

      <div class="form-group-beside row ml-0 no-border" v-if="orderinfo.third_party_uploader_email && update_allowed && orderinfo.third_party_uploader == 1 ">
        <label class="col-2 col-md-6">
          <div> </div>
        </label>
        <div class="col-10 col-md-6 input-wrapper text-right">
          <div :class="notifyUploaderStatus" v-html="notifyUploaderStatusMessage"></div>
          <button @click.prevent="notifyUploader()"><span class="d-inline-block svg-18 svg-white"><email></email></span> Send</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// register modal component
import checkmark from '../components/icons/checkmark.vue';
import caret_right from '../components/icons/caret_right.vue';
import circle_check from '../components/icons/circle_check.vue';
import closeicon from '../components/icons/close.vue';
import circle_filled from "../components/icons/circle_filled.vue";
import circle_empty from "../components/icons/circle.vue";
import email from "../components/icons/email.vue";

export default {
    components: { checkmark, closeicon, caret_right, circle_check, circle_empty, circle_filled, email},
    props: ['action_url', 'entry', 'update_allowed', 'is_viewing_mode'],
    data() {
      return {
        orderinfo: this.entry,
        thirdPartyUploaderActiveClass: '',
        notifyUploaderStatusMessage: '',
        notifyUploaderStatus: '',
      }
    },
    mounted() {
      let that = this;
      if (that.orderinfo.third_party_uploader === 1) {
        that.thirdPartyUploaderActiveClass = 'active-yes';
        that.$emit('show_video_uploader', false); // 3rd party uploading so don't show video uplaoder right now
      } else if(that.orderinfo.third_party_uploader === 0) {
        that.thirdPartyUploaderActiveClass = 'active-no';
        that.$emit('show_video_uploader', true);
      }
    },
    methods: {
      notifyUploader() {
        let that = this;
        that.notifyUploaderStatus = 'success';
        that.notifyUploaderStatusMessage = 'Sending...';
        window.axios(
            {
              method: 'put',
              url: this.action_url,
              data: {
                'third_party_uploader_name': that.orderinfo.third_party_uploader_name,
                'third_party_uploader_email': that.orderinfo.third_party_uploader_email,
                'third_party_uploader_message': that.orderinfo.third_party_uploader_message
              }
            }).then(function(response) {
          that.notifyUploaderStatus = 'success';
          that.notifyUploaderStatusMessage = 'Success: Video File Request Sent';
        }).catch(function (err) {
          let errorMessage = err.response.status + ' status error';
          app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
        });
      },
      thirdPartyUploaderActive: function(value, saveData) {
        let that = this;
        if(!that.update_allowed) {
          return false;
        }
        that.orderinfo.third_party_uploader = value;
        if(that.orderinfo.third_party_uploader == 1) {
          that.thirdPartyUploaderActiveClass = 'active-yes';
          that.$emit('show_video_uploader', false); // 3rd party uploading so don't show video uplaoder right now
        } else if (that.orderinfo.third_party_uploader == 0) {
          that.thirdPartyUploaderActiveClass = 'active-no';
          that.$emit('show_video_uploader', true);
        }
        if(saveData != 'onload') {
          this.updateForm();
        }
      },
      updateForm: function() {
        let that = this;
        let updateAction = '/entry/' + that.entry.id;
        window.axios(
            {
              method: 'post',
              url: updateAction,
              data: {
                'third_party_uploader': that.orderinfo.third_party_uploader,
              }
            }).then(function(response) {
              console.log('updated form with third party uploader')
        }).catch(function (err) {
          let errorMessage = err.response.status + ' status error';
          app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
        });
      }
    }
  }
</script>